export interface FilterOption {
  value: number
  label: string
}

// Degree Level mapping: Certificate=1, Associates=2, Bachelors=3, Master's=4
// (value 5 was a legacy "Select Option" placeholder — no longer included)
export const degreeLevelOptions: FilterOption[] = [
  { value: 1, label: 'Certificate' },
  { value: 2, label: "Associate's" },
  { value: 3, label: "Bachelor's" },
  { value: 4, label: "Master's" },
]

export const areaStudyOptions: FilterOption[] = [
  { value: 1, label: 'Business & Finance' },
  { value: 2, label: 'Criminal Justice & Legal Services' },
  { value: 3, label: 'Psychology & Counseling' },
  { value: 4, label: 'Computers & IT' },
  { value: 5, label: 'Healthcare & Medical Assisting' },
  { value: 6, label: 'Education & Teaching' },
  { value: 7, label: 'Trade, Vocational, Career' },
  { value: 8, label: 'Liberal Arts' },
  { value: 9, label: 'General' },
  { value: 10, label: 'Nursing' },
  { value: 11, label: 'Media & Communications' },
  { value: 12, label: 'Visual Arts & Graphic Design' },
  { value: 13, label: 'Religious Studies' },
]

// Full child/parent program mapping — only mProgram is sent to the API
export const programOptions: Record<number, FilterOption[]> = {
  1: [
    { value: 100, label: 'General Business' },
    { value: 101, label: 'Accounting' },
    { value: 102, label: 'Business Administration' },
    { value: 103, label: 'Business Analytics' },
    { value: 104, label: 'Communications' },
    { value: 105, label: 'Economics' },
    { value: 106, label: 'Finance' },
    { value: 107, label: 'Human Resources' },
    { value: 108, label: 'Management' },
    { value: 109, label: 'Digital Marketing & Advertising' },
    { value: 110, label: 'Project Management' },
    { value: 111, label: 'Sports Management' },
    { value: 112, label: 'Healthcare Administration' },
    { value: 113, label: 'Entrepreneurship' },
    { value: 114, label: 'Real Estate' },
    { value: 115, label: 'Office Management' },
    { value: 116, label: 'International Business' },
  ],
  2: [
    { value: 200, label: 'General Criminal Justice & Legal Services' },
    { value: 201, label: 'Corrections' },
    { value: 202, label: 'Crime Scene Investigation' },
    { value: 203, label: 'Criminal Justice' },
    { value: 204, label: 'Criminology' },
    { value: 205, label: 'Cyber Security' },
    { value: 206, label: 'Forensic Science' },
    { value: 207, label: 'Homeland Security' },
    { value: 208, label: 'Law Enforcement' },
    { value: 209, label: 'Legal & Paralegal Studies' },
    { value: 211, label: 'Public Safety Administration' },
    { value: 212, label: 'Security' },
    { value: 213, label: 'Forensic Accounting' },
    { value: 214, label: 'Fire Science' },
  ],
  3: [
    { value: 300, label: 'General Psychology & Counseling' },
    { value: 301, label: 'Addictions & Recovery' },
    { value: 302, label: 'Applied Psychology' },
    { value: 303, label: 'Behavioral Psychology' },
    { value: 304, label: 'Child and Adolescent Psychology' },
    { value: 305, label: 'Counseling' },
    { value: 307, label: 'Forensic Psychology' },
    { value: 308, label: 'Human Services' },
    { value: 310, label: 'Organizational Psychology' },
    { value: 311, label: 'Sociology' },
    { value: 312, label: 'Community Counselor' },
  ],
  4: [
    { value: 400, label: 'General Computers & IT' },
    { value: 401, label: 'Bootcamp Programs' },
    { value: 402, label: 'Computer Programming' },
    { value: 403, label: 'Data Science & Analytics' },
    { value: 404, label: 'Game Art Development' },
    { value: 405, label: 'Information Systems' },
    { value: 406, label: 'Information Technology' },
    { value: 407, label: 'IT Project Management' },
    { value: 408, label: 'Network Security' },
    { value: 409, label: 'Product and Graphic Design' },
    { value: 410, label: 'Software Engineering' },
    { value: 411, label: 'Web Development' },
    { value: 412, label: 'CyberSecurity' },
  ],
  5: [
    { value: 500, label: 'General Healthcare & Medical Assisting' },
    { value: 501, label: 'Certified Nursing Assistant (CNA)' },
    { value: 502, label: 'Allied Health' },
    { value: 503, label: 'Emergency Management (EMT)' },
    { value: 505, label: 'Health Science' },
    { value: 506, label: 'Healthcare Administration' },
    { value: 507, label: 'Healthcare Management' },
    { value: 508, label: 'Dental, Medical, or Pharmacy Technician' },
    { value: 509, label: 'Medical Billing & Coding' },
    { value: 510, label: 'Medical Office Assistant' },
    { value: 511, label: 'Nutrition, Fitness, and Sports Science' },
    { value: 512, label: 'Public Health' },
  ],
  6: [
    { value: 600, label: 'General Education & Teaching' },
    { value: 601, label: 'Adult Education/Learning' },
    { value: 602, label: 'Early Childhood Development' },
    { value: 603, label: 'Educational Administration' },
    { value: 604, label: 'K-12 Education' },
    { value: 605, label: 'Social Studies' },
    { value: 606, label: 'Special Education' },
    { value: 607, label: 'Teacher Licensure' },
  ],
  7: [
    { value: 700, label: 'General Trade, Vocational, Career' },
    { value: 701, label: 'Automotive Focused' },
    { value: 702, label: 'Aviation Focused' },
    { value: 703, label: 'Certified Nursing Assistant (CNA)' },
    { value: 704, label: 'Construction Management' },
    { value: 705, label: 'Electrical Technician' },
    { value: 706, label: 'Fire Science' },
    { value: 707, label: 'Truck Driver (CDL)' },
    { value: 708, label: 'HVAC' },
    { value: 709, label: 'Welding' },
    { value: 710, label: 'Vet Tech' },
    { value: 711, label: 'Pharmacy Tech' },
    { value: 712, label: 'Massage Therapy' },
    { value: 713, label: 'Culinary' },
  ],
  8: [
    { value: 800, label: 'General Liberal Arts' },
    { value: 801, label: 'Creative Writing & English' },
    { value: 802, label: 'Communications' },
    { value: 803, label: 'History' },
    { value: 804, label: 'Religious Studies' },
    { value: 805, label: 'Sociology' },
    { value: 806, label: 'Humanities' },
    { value: 807, label: 'Political Science' },
    { value: 808, label: 'Math Science and Engineering' },
  ],
  9: [{ value: 900, label: 'General/Undecided' }],
  10: [
    { value: 1000, label: 'All Nursing Programs (General)' },
    { value: 1001, label: 'Entry Level' },
    { value: 1002, label: 'RN Degree Programs' },
    { value: 1003, label: 'RN to BSN Bridge Programs' },
    { value: 1004, label: 'MSN Programs' },
  ],
  11: [
    { value: 1100, label: 'All Media & Communications (General)' },
    { value: 1101, label: 'Social Media Management' },
    { value: 1102, label: 'Animation & Video Graphics' },
    { value: 1103, label: 'Commercial & Advertising Art' },
    { value: 1104, label: 'Computer Media Applications' },
    { value: 1105, label: 'Design & Visual Communications' },
    { value: 1106, label: 'Film/Video & Cinematography' },
    { value: 1107, label: 'Graphic Design' },
    { value: 1108, label: 'Intermedia/Multimedia' },
    { value: 1109, label: 'Photography' },
    { value: 1110, label: 'Recording Arts Technology' },
    { value: 1111, label: 'Web Design' },
  ],
  12: [
    { value: 1200, label: 'All Visual Arts & Graphic Design (General)' },
    { value: 1201, label: 'Design & Visual Communications' },
    { value: 1202, label: 'Graphic Design' },
    { value: 1203, label: 'Industrial Design' },
    { value: 1204, label: 'Interior Design' },
    { value: 1205, label: 'Photography' },
    { value: 1206, label: 'Visual Arts' },
  ],
  13: [
    { value: 1300, label: 'All Religious Studies (General)' },
    { value: 1301, label: 'Christian Studies' },
    { value: 1302, label: 'Ministry' },
    { value: 1303, label: 'Religious Studies' },
    { value: 1304, label: 'Theology' },
    { value: 1305, label: 'Pastoral Counseling' },
  ],
}

// Helper: get the default (general) program value for an area of study
export function getDefaultProgram(areaStudyId: number): number {
  return areaStudyId * 100
}

// Helper: derive the area of study ID from a program value
// e.g. mProgram=102 → area 1 (Business), mProgram=305 → area 3 (Psychology)
export function getAreaFromProgram(mProgram: number): number {
  const areaId = Math.floor(mProgram / 100)
  // Validate it's a known area (1–13)
  if (areaId >= 1 && areaId <= 13 && programOptions[areaId]) {
    return areaId
  }
  return 1 // default to Business & Finance
}

// Helper: validate that a program value exists within its area
export function isValidProgram(mProgram: number): boolean {
  const areaId = Math.floor(mProgram / 100)
  const programs = programOptions[areaId]
  if (!programs) return false
  return programs.some((p) => p.value === mProgram)
}
